import { render, staticRenderFns } from "./cookieConfig.vue?vue&type=template&id=194fca2f&scoped=true&"
import script from "./cookieConfig.vue?vue&type=script&lang=js&"
export * from "./cookieConfig.vue?vue&type=script&lang=js&"
import style0 from "./cookieConfig.vue?vue&type=style&index=0&id=194fca2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194fca2f",
  null
  
)

export default component.exports